import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  UUID: any;
};

export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['Date']>;
  enabled: Scalars['Boolean'];
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['UUID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  users?: Maybe<Array<User>>;
};

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  addToGroup?: Maybe<AddToGroupPayload>;
  addUsers?: Maybe<AddUsersPayload>;
  createGroup?: Maybe<CreateGroupPayload>;
  createUser?: Maybe<CreateUserPayload>;
  deleteGroup?: Maybe<DeleteGroupPayload>;
  deleteUser?: Maybe<DeleteUserPayload>;
  enableGroup?: Maybe<EnableGroupPayload>;
  removeUsers?: Maybe<RemoveUsersPayload>;
  setUserEnabled?: Maybe<SetUserEnabledPayload>;
  updateGroup?: Maybe<UpdateGroupPayload>;
  updateUser?: Maybe<UpdateUserPayload>;
};


/** Mutation root */
export type MutationAddToGroupArgs = {
  input: AddToGroupInput;
};


/** Mutation root */
export type MutationAddUsersArgs = {
  input: AddUsersInput;
};


/** Mutation root */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** Mutation root */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** Mutation root */
export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


/** Mutation root */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** Mutation root */
export type MutationEnableGroupArgs = {
  input: EnableGroupInput;
};


/** Mutation root */
export type MutationRemoveUsersArgs = {
  input: RemoveUsersInput;
};


/** Mutation root */
export type MutationSetUserEnabledArgs = {
  input: SetUserEnabledInput;
};


/** Mutation root */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** Mutation root */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  disabledGroups: Array<Group>;
  disabledUsers: Array<User>;
  group?: Maybe<Group>;
  groups: Array<Group>;
  user?: Maybe<User>;
  userInfo?: Maybe<User>;
  users: Array<User>;
};


/** Query root */
export type QueryGroupArgs = {
  id: Scalars['UUID'];
};


/** Query root */
export type QueryUserArgs = {
  id: Scalars['UUID'];
};

export type User = {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Maybe<Group>>>;
  id?: Maybe<Scalars['UUID']>;
  lastName?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['UUID']>;
  updatedAt?: Maybe<Scalars['Date']>;
  username?: Maybe<Scalars['String']>;
};

export type AddToGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  userId: Scalars['String'];
};

export type AddToGroupPayload = {
  __typename?: 'addToGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<Group>;
};

export type AddUsersInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AddUsersPayload = {
  __typename?: 'addUsersPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<Group>;
};

export type CreateGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CreateGroupPayload = {
  __typename?: 'createGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<Group>;
};

export type CreateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  username: Scalars['String'];
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<User>;
};

export type DeleteGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type DeleteGroupPayload = {
  __typename?: 'deleteGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<Group>;
};

export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<User>;
};

export type EnableGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type EnableGroupPayload = {
  __typename?: 'enableGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<Group>;
};

export type RemoveUsersInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RemoveUsersPayload = {
  __typename?: 'removeUsersPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<Group>;
};

export type SetUserEnabledInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
};

export type SetUserEnabledPayload = {
  __typename?: 'setUserEnabledPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<User>;
};

export type UpdateGroupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type UpdateGroupPayload = {
  __typename?: 'updateGroupPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<Group>;
};

export type UpdateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  lastName: Scalars['String'];
  username: Scalars['String'];
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** Mutation result */
  result?: Maybe<User>;
};

export type GroupListQueryVariables = Exact<{ [key: string]: never; }>;


export type GroupListQuery = { __typename?: 'Query', groups: Array<{ __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null, users?: Array<{ __typename?: 'User', id?: any | null, username?: string | null, enabled: boolean }> | null }> };

export type GetGroupQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGroupQuery = { __typename?: 'Query', group?: { __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null, users?: Array<{ __typename?: 'User', id?: any | null, username?: string | null, enabled: boolean }> | null } | null };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'Mutation', createGroup?: { __typename?: 'createGroupPayload', result?: { __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null, users?: Array<{ __typename?: 'User', id?: any | null, username?: string | null, enabled: boolean }> | null } | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup?: { __typename?: 'updateGroupPayload', result?: { __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null } | null } | null };

export type AddUsersMutationVariables = Exact<{
  input: AddUsersInput;
}>;


export type AddUsersMutation = { __typename?: 'Mutation', addUsers?: { __typename?: 'addUsersPayload', result?: { __typename?: 'Group', id?: any | null, name?: string | null, users?: Array<{ __typename?: 'User', id?: any | null }> | null } | null } | null };

export type RemoveUsersMutationVariables = Exact<{
  input: RemoveUsersInput;
}>;


export type RemoveUsersMutation = { __typename?: 'Mutation', removeUsers?: { __typename?: 'removeUsersPayload', result?: { __typename?: 'Group', id?: any | null, name?: string | null, users?: Array<{ __typename?: 'User', id?: any | null }> | null } | null } | null };

export type UserListQueryVariables = Exact<{ [key: string]: never; }>;


export type UserListQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id?: any | null, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null, groups?: Array<{ __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean } | null> | null }> };

export type GetUserQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id?: any | null, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null, groups?: Array<{ __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean } | null> | null } | null };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', userInfo?: { __typename?: 'User', id?: any | null, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null, groups?: Array<{ __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean } | null> | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'createUserPayload', result?: { __typename?: 'User', id?: any | null, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null, groups?: Array<{ __typename?: 'Group', id?: any | null, name?: string | null, enabled: boolean } | null> | null } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename?: 'deleteUserPayload', result?: { __typename?: 'User', id?: any | null } | null } | null };

export type SetUserEnabledMutationVariables = Exact<{
  input: SetUserEnabledInput;
}>;


export type SetUserEnabledMutation = { __typename?: 'Mutation', setUserEnabled?: { __typename?: 'setUserEnabledPayload', result?: { __typename?: 'User', id?: any | null, enabled: boolean } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'updateUserPayload', result?: { __typename?: 'User', id?: any | null, username?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null, enabled: boolean, createdAt?: any | null, updatedAt?: any | null } | null } | null };


export const GroupListDocument = gql`
    query GroupList {
  groups {
    id
    name
    enabled
    createdAt
    updatedAt
    users {
      id
      username
      enabled
    }
  }
}
    `;

export function useGroupListQuery(options?: Omit<Urql.UseQueryArgs<GroupListQueryVariables>, 'query'>) {
  return Urql.useQuery<GroupListQuery, GroupListQueryVariables>({ query: GroupListDocument, ...options });
};
export const GetGroupDocument = gql`
    query GetGroup($id: UUID!) {
  group(id: $id) {
    id
    name
    enabled
    createdAt
    updatedAt
    users {
      id
      username
      enabled
    }
  }
}
    `;

export function useGetGroupQuery(options: Omit<Urql.UseQueryArgs<GetGroupQueryVariables>, 'query'>) {
  return Urql.useQuery<GetGroupQuery, GetGroupQueryVariables>({ query: GetGroupDocument, ...options });
};
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: createGroupInput!) {
  createGroup(input: $input) {
    result {
      id
      name
      enabled
      createdAt
      updatedAt
      users {
        id
        username
        enabled
      }
    }
  }
}
    `;

export function useCreateGroupMutation() {
  return Urql.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument);
};
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: updateGroupInput!) {
  updateGroup(input: $input) {
    result {
      id
      name
      enabled
      createdAt
      updatedAt
    }
  }
}
    `;

export function useUpdateGroupMutation() {
  return Urql.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument);
};
export const AddUsersDocument = gql`
    mutation AddUsers($input: addUsersInput!) {
  addUsers(input: $input) {
    result {
      id
      name
      users {
        id
      }
    }
  }
}
    `;

export function useAddUsersMutation() {
  return Urql.useMutation<AddUsersMutation, AddUsersMutationVariables>(AddUsersDocument);
};
export const RemoveUsersDocument = gql`
    mutation RemoveUsers($input: removeUsersInput!) {
  removeUsers(input: $input) {
    result {
      id
      name
      users {
        id
      }
    }
  }
}
    `;

export function useRemoveUsersMutation() {
  return Urql.useMutation<RemoveUsersMutation, RemoveUsersMutationVariables>(RemoveUsersDocument);
};
export const UserListDocument = gql`
    query UserList {
  users {
    id
    username
    email
    firstName
    lastName
    enabled
    createdAt
    updatedAt
    groups {
      id
      name
      enabled
    }
  }
}
    `;

export function useUserListQuery(options?: Omit<Urql.UseQueryArgs<UserListQueryVariables>, 'query'>) {
  return Urql.useQuery<UserListQuery, UserListQueryVariables>({ query: UserListDocument, ...options });
};
export const GetUserDocument = gql`
    query GetUser($id: UUID!) {
  user(id: $id) {
    id
    username
    email
    firstName
    lastName
    enabled
    createdAt
    updatedAt
    groups {
      id
      name
      enabled
    }
  }
}
    `;

export function useGetUserQuery(options: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetUserInfoDocument = gql`
    query GetUserInfo {
  userInfo {
    id
    username
    email
    firstName
    lastName
    enabled
    createdAt
    updatedAt
    groups {
      id
      name
      enabled
    }
  }
}
    `;

export function useGetUserInfoQuery(options?: Omit<Urql.UseQueryArgs<GetUserInfoQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>({ query: GetUserInfoDocument, ...options });
};
export const CreateUserDocument = gql`
    mutation CreateUser($input: createUserInput!) {
  createUser(input: $input) {
    result {
      id
      username
      email
      firstName
      lastName
      enabled
      createdAt
      updatedAt
      groups {
        id
        name
        enabled
      }
    }
  }
}
    `;

export function useCreateUserMutation() {
  return Urql.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument);
};
export const DeleteUserDocument = gql`
    mutation DeleteUser($input: deleteUserInput!) {
  deleteUser(input: $input) {
    result {
      id
    }
  }
}
    `;

export function useDeleteUserMutation() {
  return Urql.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument);
};
export const SetUserEnabledDocument = gql`
    mutation SetUserEnabled($input: setUserEnabledInput!) {
  setUserEnabled(input: $input) {
    result {
      id
      enabled
    }
  }
}
    `;

export function useSetUserEnabledMutation() {
  return Urql.useMutation<SetUserEnabledMutation, SetUserEnabledMutationVariables>(SetUserEnabledDocument);
};
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: updateUserInput!) {
  updateUser(input: $input) {
    result {
      id
      username
      email
      firstName
      lastName
      enabled
      createdAt
      updatedAt
    }
  }
}
    `;

export function useUpdateUserMutation() {
  return Urql.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument);
};